<div fxFill fxLayout="column">
    <h1 class="mat-h1">Import Assignment</h1>
    <div *ngIf="!assignment">
        <div fxLayout="row" fxLayoutGap="10px">
            <div class="search-wrap">
                <mat-icon matPrefix>search</mat-icon> <input type="search" name="importSearchAbbr" autocomplete="importSearchAbbr" id="importSearchAbbr{{importSearchAbbr}}" matInput placeholder="Search Abbreviations" [formControl]="controlAbbr">
            </div>
            <div class="search-wrap">
                <mat-icon matPrefix>search</mat-icon> <input type="search" name="importSearchTitle" autocomplete="importSearchTitle" id="importSearchTitle{{importSearchTitle}}" matInput placeholder="Search Titles" [formControl]="controlTitle">
            </div>
            <mat-form-field>
                <mat-select placeholder="Select Sites" [formControl]="controlSite" multiple>
                    <mat-select-trigger>
                        <a 
                            *ngFor="let site of properties; trackBy: utils.trackByIndex"
                            class="site-{{site.abbreviation}}">
                                {{site.abbreviation}}
                        </a>
                    </mat-select-trigger>
                    <mat-checkbox class="mat-form-field-infix select-all" [formControl]="controlSelectAll">Select All</mat-checkbox>
                    <mat-option *ngFor="let prop of properties" [value]="prop">
                        <a 
                            class="site-{{prop.abbreviation}}">
                                {{prop.abbreviation}}
                        </a> {{prop.domain}}
                    </mat-option>
                </mat-select>
            </mat-form-field>     
        </div>    
        <div class="results" *ngIf="results.length > 0">
            <mat-table #table [dataSource]="results">
    
                <!-- site -->
                <ng-container matColumnDef="site">
                    <mat-header-cell *matHeaderCellDef> Site </mat-header-cell>
                    <mat-cell *matCellDef="let item">
                        <ng-container *ngIf="connectMode === true; else singleSite">
                            <a 
                                *ngFor="let site of item.sites"
                                title="{{site?.permalink}}" 
                                href="{{site?.permalink}}" 
                                target="_blank" 
                                class="site-{{site.abbreviation}}"
                                [ngClass]="{primary: site.primary}">
                                    {{site.abbreviation}}
                            </a>
                        </ng-container>
                        <ng-template #singleSite>
                            <a
                                title="{{item?.permalink}}" 
                                href="{{item?.permalink}}" 
                                target="_blank" 
                                class="site-{{item.site_abbr}}">
                                    {{item.site_abbr}}
                            </a>
                        </ng-template>
                        
                    </mat-cell>
                </ng-container>
    
                <!-- abbr -->
                <ng-container matColumnDef="abbr">
                    <mat-header-cell *matHeaderCellDef> Abbr </mat-header-cell>
                    <mat-cell *matCellDef="let item"> {{item.abbreviation}} </mat-cell>
                </ng-container>
    
                <!-- title -->
                <ng-container matColumnDef="title">
                    <mat-header-cell *matHeaderCellDef> Title </mat-header-cell>
                    <mat-cell *matCellDef="let item" [attr.title]="item.title" [innerHtml]="item.title"></mat-cell>
                </ng-container>
    
                <!-- slug -->
                <ng-container matColumnDef="slug">
                    <mat-header-cell *matHeaderCellDef> Slug </mat-header-cell>
                    <mat-cell *matCellDef="let item"> {{item.slug}} </mat-cell>
                </ng-container>
    
                <!-- date -->
                <ng-container matColumnDef="date">
                    <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                    <mat-cell *matCellDef="let item"> {{item.date | date : short}} </mat-cell>
                </ng-container>
    
                <!-- actions -->
                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let item; let i = index"> 
                        <a class="button{{ connectMode ? '' : ' secondary' }}"
                            *ngIf="item.swarm_id || connectMode; else importBtn"
                            (click)="maybeNavigate($event, item)"
                            [href]="item.swarm_id ? '/slideshow/' + item.swarm_id : ''">
                                {{connectMode ? 'Select' : 'View'}}
                        </a> 
                        <ng-template #importBtn>
                            <button 
                                class="button"
                                (click)="addPost(item, selectedForImport)">
                                Select
                            </button>
                        </ng-template>
                    </mat-cell>
                </ng-container>
    
                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns" [ngClass]="{disabled: connectMode === true && !row.swarm_id}"></mat-row>
            </mat-table>
            <mat-paginator paginator3 [length]="found" [pageSize]="15" (page)="pageChange($event)"></mat-paginator>
        </div>
        <div id="selected-table" *ngIf="selected.length > 0">
            <h2>The following posts will be connected to a single assignment:</h2>
            <mat-table #selectedTable [dataSource]="selected">

                <!-- primary -->
                <ng-container matColumnDef="primary">
                    <mat-header-cell *matHeaderCellDef> Primary </mat-header-cell>
                    <mat-cell *matCellDef="let item;">
                        <mat-checkbox [(ngModel)]="item.primary" (change)="primaryChange($event, item)" [disabled]="connectMode === true">&nbsp;</mat-checkbox>
                    </mat-cell>
                </ng-container>

                <!-- site -->
                <ng-container matColumnDef="site">
                    <mat-header-cell *matHeaderCellDef> Site </mat-header-cell>
                    <mat-cell *matCellDef="let item">
                        <a 
                            *ngFor="let site of item.sites"
                            title="{{site?.permalink}}" 
                            href="{{site?.permalink}}" 
                            target="_blank" 
                            class="site-{{site.abbreviation}}"
                            [ngClass]="{primary: site.primary}">
                                {{site.abbreviation}}
                        </a>
                    </mat-cell>
                </ng-container>

                <!-- abbr -->
                <ng-container matColumnDef="abbr">
                    <mat-header-cell *matHeaderCellDef> Abbr </mat-header-cell>
                    <mat-cell *matCellDef="let item"> {{item.abbreviation}} </mat-cell>
                </ng-container>

                <!-- title -->
                <ng-container matColumnDef="title">
                    <mat-header-cell *matHeaderCellDef> Title </mat-header-cell>
                    <mat-cell *matCellDef="let item" [attr.title]="item.title" [innerHtml]="item.title"></mat-cell>
                </ng-container>

                <!-- slug -->
                <ng-container matColumnDef="slug">
                    <mat-header-cell *matHeaderCellDef> Slug </mat-header-cell>
                    <mat-cell *matCellDef="let item"> {{item.slug}} </mat-cell>
                </ng-container>

                <!-- date -->
                <ng-container matColumnDef="date">
                    <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                    <mat-cell *matCellDef="let item"> {{item.date | date : short}} </mat-cell>
                </ng-container>

                <!-- remove -->
                <ng-container matColumnDef="remove">
                    <mat-header-cell *matHeaderCellDef> Remove </mat-header-cell>
                    <mat-cell *matCellDef="let item; let i = index">
                        <mat-icon (click)="removePost(i, item)" *ngIf="connectMode !== true || item.swarm_id">close</mat-icon>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="selectedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: selectedColumns" [ngClass]="{primary: row.primary}"></mat-row>
            </mat-table>
            <ng-container *ngIf="connectMode === false; else connectBtns">
                <button (click)="enterConnectMode()" class="left button">Connect</button>
                <button (click)="getAssignment()" class="right button">Import</button>
            </ng-container>
            <ng-template #connectBtns>
                <button (click)="connect()" class="right button">Connect</button>
                <button (click)="exitConnectMode()" class="right button">Cancel</button>
            </ng-template>
            <span class="right">{{selectTableMessage}}</span>
        </div>
        <div #selectedForImport></div>
    </div>
    <mat-horizontal-stepper #stepper *ngIf="assignment" [linear]="true">
        <!-- icons -->
        <ng-template matStepperIcon="edit">
            <mat-icon>done</mat-icon>
        </ng-template>

        <mat-step #step1 label="Review Assignment" [completed]="false">

            <div fxLayout="row" fxLayoutGap="10px">
                <!-- assignment title -->
                <mat-form-field fxFlex="100">
                    <span>
                        <input matInput name="importAssignmentTitle" autocomplete="importAssignmentTitle" id="importAssignmentTitle{{importAssignmentTitle}}" placeholder="Assignment Title" [(ngModel)]="assignment.title">
                    </span>    
                </mat-form-field>

                <!-- abbreviation -->
                <mat-form-field>
                    <input matInput name="importAssignmentAbbr" autocomplete="importAssignmentAbbr" id="importAssignmentAbbr{{importAssignmentAbbr}}" placeholder="Ad Acronym" [(ngModel)]="assignment.abbreviation">
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutGap="10px">
                <!-- title -->
                <mat-form-field fxFlex="100">
                    <input matInput name="importAssignmentArticleTitle" autocomplete="importAssignmentArticleTitle" id="importAssignmentArticleTitle{{importAssignmentArticleTitle}}" placeholder="Article Title" [(ngModel)]="assignment.articleTitle">
                </mat-form-field>
            </div>
            <div fxLayout="column" fxLayoutWrap layoutAlign="start end" fxLayoutGap="10px">
                <!-- properties -->
                <properties-component 
                    [(properties)]="assignment.sites"
                    [canEdit]="false"
                    [editSlug]="false"
                    [showMeta]="false"
                    [assignment]="assignment">
                </properties-component>

                <div fxLayoutGap="10px">
                    <!-- tags -->
                    <tags-component fxFlex="50"
                        id="tags"
                        [(termIds)]="assignment.tags"
                        [canEdit]="true">
                    </tags-component>
                </div>
            </div>
            <div fxLayout="row" fxLayoutWrap layoutAlign="start end" fxLayoutGap="10px">
    
                <!-- team -->
                <team-component 
                    [(team)]="teamService.team"
                    (teamChanged)="teamService.updateAssignment($event, assignment)"
                    [canEdit]="true">
                </team-component>

            </div>
            <div fxLayout="row">
                <!-- notes -->
                <notes-component #notes [(id)]="assignment.id" (commentsChange)="addComment($event)"></notes-component>
            </div>
            <div class="actions">
                <button class="button clear" (click)="cancel()" [disabled]="importInProgress">Cancel</button>
                <button class="button" (click)="getSlides(stepper, step1)">Review Slides</button>
            </div>
        </mat-step>
        <mat-step #step2 label="Review Slides" [completed]="false">
            <mat-paginator 
                #paginator1
                [length]="slideCount"
                [pageSize]="10"
                (page)="slidePageChange($event)">
            </mat-paginator>
            <!-- featured image -->
            <div *ngIf="currentPageIndex == 0 && slides && slides.length > 0" fxLayout="column">
                <mat-divider></mat-divider>
                    <h2 class="page-title">Featured Image</h2>
                <mat-divider></mat-divider>
                <div class="image" fxFlex="100" *ngIf="slides[0].images.length > 0">
                    <img src="{{slides[0].images[0]}}" />              
                </div>
            </div>
            
            <!-- slides -->
            <div *ngFor="let slide of slides | paginate: paginator : assignment.quiz : assignment.intro; let i = index" fxLayout="column">
                <!-- page number -->
                <div *ngIf="currentPageIndex > 0 || (currentPageIndex == 0 && slides[0].intro && i !== 1) || assignment.quiz || (currentPageIndex == 0 && !slides[0].intro)">
                    <mat-divider></mat-divider>
                        <h2 class="page-title">Page {{getPageNumber(i)}}</h2>
                    <mat-divider></mat-divider>
                </div>  
                <!-- h2 -->
                <h3 class="mat-h2" *ngIf="(!assignment.quiz && !slide.intro) || (assignment.quiz && !slide.outro && !slide.intro)">
                    <richtext 
                        placeholder="{{assignment.childType == 'quiz' ? 'Question' : 'Slide Headline'}}"
                        [(value)]="slide.title">
                    </richtext>
                </h3>
                <!-- images --> 
                <div class="images" fxFlex="100" *ngIf="!slide.outro">
                    <div class="image" *ngFor="let url of slide.images; let imgIndex = index">
                        <img *ngIf="!slide.intro || (assignment.quiz && slide.intro && imgIndex > 0)" src="{{url}}" />
                    </div>                    
                </div>
                <!-- caption --> 
                <div class="caption">
                    <div *ngFor="let caption of slide.caption; let capIndex = index">
                        <richtext 
                            placeholder="Image Caption"
                            [(value)]="slide.caption[capIndex].text">
                        </richtext>
                    </div>
                </div>
                <!-- content --> 
                <div class="content">
                    <div
                        fxLayout="row" 
                        fxLayoutGap="{{assignment.quiz ? '20px' : ''}}" 
                        fxLayoutAlign="center center" 
                        *ngFor="let content of slide.content; let contentIndex = index">
                            <mat-checkbox
                                *ngIf="assignment.quiz && !slide.intro && !slide.outro"
                                class="correct"
                                name="answer-correct-{{contentIndex}}" 
                                [(ngModel)]="slide.content[contentIndex].correct">
                            </mat-checkbox>
                            <div *ngIf="assignment.quiz && slide.outro">
                                <img src="{{slide.content[contentIndex].image}}">
                            </div>
                            <richtext 
                                placeholder="{{getContentPlaceholder(slide, contentIndex)}}"
                                [(value)]="slide.content[contentIndex].text">
                            </richtext>
                    </div>
                </div>
                <!-- teaser --> 
                <mat-form-field fxFlex="100" *ngIf="!assignment.quiz && slide.teaser">
                    <input matInput name="importAssignmentTeaser" autocomplete="importAssignmentTeaser" id="importAssignmentTeaser{{importAssignmentTeaser}}" [(ngModel)]="slide.teaser" placeholder="Teaser"/>
                </mat-form-field>
                <!-- quiz answer summary --> 
                <div *ngIf="assignment.quiz && !slide.outro && !slide.intro">
                    <div *ngFor="let feedback of slide.feedback; let feedbackIndex = index">
                        <richtext 
                            [(value)]="slide.feedback[feedbackIndex].text"
                            placeholder="Correct Answer Summary">
                        </richtext>
                    </div>
                </div>
            </div>
            <mat-paginator 
                #paginator2
                [length]="slideCount"
                [pageSize]="10"
                (page)="slidePageChange($event, true)">
            </mat-paginator>
            <div class="actions">
                <button class="button clear" matStepperPrevious>Back</button>
                <button class="button clear" (click)="cancel()" [disabled]="importInProgress">Cancel</button>
                <button class="button" (click)="readyToImport(stepper, step2)">Ready to Import</button>
            </div>
        </mat-step>
        <mat-step label="Import" [completed]="false" #step3>
            <h2 *ngIf="importSuccess === false">Import failed.</h2>
            <p *ngIf="importSuccess === false">Unable to import assignment.</p>
            <div *ngFor="let message of importMessages">
                <p [ngClass]="{error: message.error}" [innerHtml]="message.text"></p>
            </div>
            <div class="actions">
                <button class="button clear" matStepperPrevious>Back</button>
                <button class="button clear" (click)="cancel()" [disabled]="importInProgress">Cancel</button>
                <button class="button" (click)="import(step3)" [disabled]="importInProgress">Begin Import</button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>